export const isDinnerSpeaker = (act) => {
  if (!act) return false;

  return (
    act.act_category?.includes('dinner-speakers') ||
    act.parentCategory === 'dinner-speakers' ||
    act.categories?.some((cat) => cat.toLowerCase().includes('dinner speaker')) ||
    act.genre === 'Dinner Speaker'
  );
};

export const isThemedNight = (act) => {
  if (!act) return false;

  return (
    act.act_category?.includes('themed-nights') ||
    act.categories?.some((cat) => cat.toLowerCase().includes('themed night')) ||
    act.genre === 'Themed Night'
  );
};
